module.exports = __webpack_public_path__ + "static/media/whiteAdd.fc7d00a5.svg";